/**
 * SmartArt preset library — one entry per diagram template the toolbar offers.
 * `createSmartArtObject(presetId)` returns the stored data shape (nodes/theme/layout).
 */
import { makeNodeId, SMART_ART_PALETTES, DEFAULT_THEME, tintColor } from './smartArtUtils';

const seed = (texts) => texts.map((t) => ({ id: makeNodeId(), text: t.text, level: t.level }));

export const SMART_ART_PRESETS = {
  'list-vertical': {
    label: 'Vertical List',
    layout: 'list',
    variant: 'vertical',
    theme: { ...DEFAULT_THEME, name: 'blue', palette: SMART_ART_PALETTES.blue },
    nodes: [
      { text: 'First item', level: 0 },
      { text: 'Second item', level: 0 },
      { text: 'Third item', level: 0 },
    ],
  },
  'list-horizontal': {
    label: 'Horizontal List',
    layout: 'list',
    variant: 'horizontal',
    theme: { ...DEFAULT_THEME, name: 'green', palette: SMART_ART_PALETTES.green },
    nodes: [
      { text: 'Item A', level: 0 },
      { text: 'Item B', level: 0 },
      { text: 'Item C', level: 0 },
    ],
  },
  'process-horizontal': {
    label: 'Process',
    layout: 'process',
    variant: 'horizontal',
    theme: {
      ...DEFAULT_THEME,
      name: 'blue',
      palette: SMART_ART_PALETTES.blue,
      connectorColor: tintColor(SMART_ART_PALETTES.blue[0], 0.45),
    },
    nodes: [
      { text: 'Step 1', level: 0 },
      { text: 'Step 2', level: 0 },
      { text: 'Step 3', level: 0 },
    ],
  },
  'process-vertical': {
    label: 'Vertical Process',
    layout: 'process',
    variant: 'vertical',
    theme: {
      ...DEFAULT_THEME,
      name: 'purple',
      palette: SMART_ART_PALETTES.purple,
      connectorColor: tintColor(SMART_ART_PALETTES.purple[0], 0.45),
    },
    nodes: [
      { text: 'Step 1', level: 0 },
      { text: 'Step 2', level: 0 },
      { text: 'Step 3', level: 0 },
    ],
  },
  cycle: {
    label: 'Cycle',
    layout: 'cycle',
    theme: {
      ...DEFAULT_THEME,
      name: 'warm',
      palette: SMART_ART_PALETTES.warm,
      connectorColor: tintColor(SMART_ART_PALETTES.warm[0], 0.45),
    },
    nodes: [
      { text: 'Phase 1', level: 0 },
      { text: 'Phase 2', level: 0 },
      { text: 'Phase 3', level: 0 },
      { text: 'Phase 4', level: 0 },
    ],
  },
  hierarchy: {
    label: 'Hierarchy',
    layout: 'hierarchy',
    theme: { ...DEFAULT_THEME, name: 'blue', palette: SMART_ART_PALETTES.blue },
    nodes: [
      { text: 'Lead', level: 0 },
      { text: 'Team A', level: 1 },
      { text: 'Team B', level: 1 },
      { text: 'Member', level: 2 },
    ],
  },
  pyramid: {
    label: 'Pyramid',
    layout: 'pyramid',
    theme: { ...DEFAULT_THEME, name: 'warm', palette: SMART_ART_PALETTES.warm },
    nodes: [
      { text: 'Vision', level: 0 },
      { text: 'Strategy', level: 0 },
      { text: 'Execution', level: 0 },
    ],
  },
};

export const createSmartArtObject = (presetId) => {
  const preset = SMART_ART_PRESETS[presetId];
  if (!preset) throw new Error(`Unknown SmartArt preset: ${presetId}`);
  return {
    layout: preset.layout,
    variant: preset.variant || null,
    theme: preset.theme,
    nodes: seed(preset.nodes),
  };
};
